<template>
    <div class="container">
        <h1 style="margin-bottom: 0;">Add Scale</h1>

        <div style="display: flex; justify-content: center;">
            <div>
                <h4>Name</h4>
                <input type="text" id="scalename" required />
            </div>
        </div>
        <div class="optionsContainer">
            <h2 style="margin: 0; text-align: left;">Options</h2>

            <div v-for="(option, index) in options" v-bind:key="option.id" class="optiondisplay">
                <h2 style="margin-top: 2.9rem;">{{ index + 1 }}</h2>
                <div>
                    <h4 style="margin-top:0.3rem;">Text</h4>
                    <input type="text" class="inlineinput" :id="'optiontext' + option.id" />
                </div>
                <div>
                    <h4 style="margin-top:0.3rem;">Points</h4>
                    <input type="number" class="inlineinput" step="1" :id="'optionpoints' + option.id" />
                </div>

                <button class="iconButton" @click="deleteOption(option.id)" style="margin-top: 1.5rem;">
                    <span class="material-symbols-outlined">
                        delete_forever
                    </span>
                </button>
            </div>

            <div style="display: flex; justify-content: right;">
                <button @click="addOption()">
                    <h4>Add option</h4>
                </button>
            </div>
        </div>
        <div class="desctext">
            <div>
                <h4>Left text</h4>
                <input type="text" id="ltext" required />
            </div>
            <div>
                <h4>Center text</h4>
                <input type="text" id="ctext" required />
            </div>
            <div>
                <h4>Right text</h4>
                <input type="text" id="rtext" required />
            </div>
        </div>

        <button @click="submit()">
            <h2>Create</h2>
        </button>
        <h5 id="fillalltext" style="text-align: center;">Please add name and options.</h5>
    </div>
</template>

<script>
import accountStore from "../accountStore";
import axios from "axios";
import { baseurl } from "../api";

export default {
    methods: {
        submit() {
            const scaleName = document.getElementById("scalename").value;

            if (scaleName === "" || this.options.length === 0) {
                document.getElementById("fillalltext").classList.add("shown");
                return;
            }

            for (const option in this.options) {
                this.options[option].label = document.getElementById("optiontext" + this.options[option].id).value;
                this.options[option].points = parseInt(document.getElementById("optionpoints" + this.options[option].id).value);
            }
            console.log(this.options);


            axios.post(baseurl + "createscale", {
                name: scaleName,
                ltext: document.getElementById("ltext").value,
                ctext: document.getElementById("ctext").value,
                rtext: document.getElementById("rtext").value,
                options: this.options,
                p: accountStore.passcode
            })
                .then((r) => {
                    if (r.data.success) {
                        this.$router.push("/manage");
                        return;
                    }
                });
        },
        addOption() {
            this.lastId += 1;
            this.options.push({ id: this.lastId, label: "label", points: 0 });
        },
        deleteOption(id) {
            this.options = this.options.filter((o) => { return o.id !== id; });
        }
    },
    created() {
        if (!accountStore.verified) {
            this.$router.push("/admin");
        }
        window.addEventListener("keydown", (e) => {
            if (e.key === "Enter") {
                this.submit();
            }
        });
    },
    data() {
        return {
            lastId: 0,
            options: [],
        };
    },
    name: "AddScale",
};
</script>

<style scoped>
.iconButton {
    color: #ffffff;
    padding: 0.5rem 0.6rem;
    border-radius: 9999px;
    margin-top: 0;
}

.optiondisplay {
    border-bottom: 1px solid #aaaaaa;
    padding: 0;
    padding-bottom: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.optionsContainer {
    border: 1px solid #ffffff;
    border-radius: 1rem;
    padding: 1.5rem 2rem;
    margin: 0.5rem 1rem;
    margin-top: 2.5rem;
}

.desctext {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    margin-bottom: 2rem;
}

h4 {
    text-align: left;
    margin-bottom: 0.1rem;
    margin-left: 1.5rem;
    margin-top: 1.5rem;
}

.container {
    margin-bottom: 2rem;
}

input {
    border: 1px solid #555555;
    border-radius: 1rem;
    padding: 0.6rem 1rem;
    margin: 0 1rem;
    font-size: 1rem;
    font-weight: bold;
    width: 10rem;
}

.errored {
    border: 1px solid #ff0000;
}

.errored:focus {
    outline-color: #ff0000;
}

button {
    background-color: #007bff;
    border: none;
    border-radius: 1rem;
    cursor: pointer;
    margin-top: 0.5rem;
}

button>h2 {
    color: #ffffff;
    margin: 0.8rem 1rem;
}

button>h4 {
    color: #ffffff;
    margin: 0.6rem 0.8rem;
}

.inputrow {
    display: flex;
    align-items: center;
}

h5 {
    text-align: left;
    margin: 0.3rem 1.7rem;
    color: #c70000;
    visibility: hidden;
}

.shown {
    visibility: visible;
}
</style>
